import { render, staticRenderFns } from "./MarksRootView.vue?vue&type=template&id=35cc81d0"
import script from "./MarksRootView.vue?vue&type=script&lang=js"
export * from "./MarksRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports